/* Dogs Supreme — PDP Variant-Image Auto-Scroll v3 (2026-05-11)
 * KOMPLETT NEU. Vorgaenger (Sticky-Pattern + Pulse) verworfen — funktionierte nicht zuverlaessig.
 *
 * Verhalten:
 * - Bei JEDEM variant:change auf Mobile (<=768px) oder Tablet: scroll smooth zum Hauptbild,
 *   sodass das Bild im oberen Drittel des Viewports landet (Augenhoehe-Position).
 * - Auf Desktop: keine Aktion (Bild ist sowieso links statisch sichtbar).
 *
 * Tracking: dataLayer.push `ds_variant_image_revealed` (GTM-Trigger noetig).
 */

(function() {
  'use strict';

  // Desktop ueberspringen
  if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;

  var DEBUG = /[?&]ds_debug=1/.test(location.search);
  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[DS-VariantScroll]'].concat(Array.prototype.slice.call(arguments)));
  }

  // Image-Wrapper finden: erst v23-Klasse, dann Theme-Fallback
  function findImageWrap() {
    return document.querySelector('.js-pdp-sticky-mobile[data-variant-image-sync]') ||
           document.querySelector('.product__main-photos') ||
           document.querySelector('[data-product-single-media-group]') ||
           document.querySelector('[data-product-photos]');
  }

  function getHeaderHeight() {
    var hdr = document.querySelector('.site-header') ||
              document.querySelector('header') ||
              document.querySelector('.sn-header');
    return (hdr && hdr.offsetHeight) || 56;
  }

  function scrollToImage(variant) {
    var imgWrap = findImageWrap();
    if (!imgWrap) {
      log('imageWrap not found');
      return;
    }

    var headerH = getHeaderHeight();
    var rect = imgWrap.getBoundingClientRect();
    var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var imgPageTop = rect.top + pageY;
    var imgHeight = imgWrap.offsetHeight || rect.height || 375;

    // Ziel: Bild im oberen 25% des Viewports (Apple-Style „prominent placement")
    // - Wenn Bild kleiner als Viewport: 25% vom Top als breathing-space, Bild dominant
    // - Wenn Bild groesser als Viewport: knapp unter Header
    var vh = window.innerHeight;
    var spaceAbove;
    if (imgHeight + headerH + 32 >= vh) {
      spaceAbove = headerH + 8;
    } else {
      // 25% des verfuegbaren Platzes ueber dem Bild
      spaceAbove = headerH + Math.max(8, (vh - headerH - imgHeight) * 0.25);
    }
    var targetY = Math.max(0, imgPageTop - spaceAbove);

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    log('scrolling to', { targetY: targetY, imgPageTop: imgPageTop, spaceAbove: spaceAbove, vh: vh, imgH: imgHeight });

    try {
      window.scrollTo({ top: targetY, behavior: reducedMotion ? 'instant' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, targetY);
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ds_variant_image_revealed',
        variant_id: variant ? variant.id : null,
        method: 'auto_scroll'
      });
    }
  }

  // Hauptsache-Listener: Variant-Wechsel triggert IMMER scroll-to-image
  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      scrollToImage(e.detail.variant);
    }
  });

  // Fallback: ds:variantImageChanged (von theme.js patch dispatched)
  document.addEventListener('ds:variantImageChanged', function(e) {
    if (e.detail && e.detail.variant) {
      // Kleiner Delay damit Flickity-Bild zuerst aktualisieren kann
      setTimeout(function() { scrollToImage(e.detail.variant); }, 50);
    }
  });

  // Direkter Click-Listener auf Color-Swatches als zusaetzlicher Trigger
  // (variant:change feuert manchmal mit Verzoegerung)
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-color-swatch], .color-swatch, [data-variant-swatch]');
    if (!swatch) return;
    // 80ms warten damit theme.js die Variant aktualisiert hat
    setTimeout(function() { scrollToImage(null); }, 80);
  });

  log('initialized, breakpoint mobile/tablet');
})();
